module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('AppBlockWrapper', [_c('BreadcrumbsLayout', {
    attrs: {
      "breadcrumbs": _vm.crumbs
    }
  }, [(_vm.nothingFound) ? _c('PageError') : _c('AppCardTotalLayout', [_c('AppHeading', {
    attrs: {
      "slot": "heading"
    },
    slot: "heading"
  }, [_vm._v(_vm._s(_vm.name))]), _c('AppPicture', {
    attrs: {
      "slot": "slider",
      "image": _vm.image,
      "alt": _vm.name
    },
    slot: "slider"
  }), _c('template', {
    slot: "sidebar"
  }, [(_vm.workPlacesNames) ? _c('div', [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "bold"
    }
  }, [_vm._v("Место работы:")]), _c('AppText', {
    attrs: {
      "mod": "small"
    }
  }, [_vm._v(_vm._s(_vm.workPlacesNames))])], 1) : _vm._e(), (_vm.educationLevel) ? _c('div', [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "bold"
    }
  }, [_vm._v("Требуемый уровень образования:")]), _c('AppText', {
    attrs: {
      "mod": "small"
    }
  }, [_vm._v(_vm._s(_vm.educationLevel))])], 1) : _vm._e(), (_vm.workType) ? _c('div', [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "bold"
    }
  }, [_vm._v("Вид труда:")]), _c('AppText', {
    attrs: {
      "mod": "small"
    }
  }, [_vm._v(_vm._s(_vm.workType))])], 1) : _vm._e(), (_vm.workSphere) ? _c('div', [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "bold"
    }
  }, [_vm._v("Сфера труда:")]), _c('AppText', {
    attrs: {
      "mod": "small"
    }
  }, [_vm._v(_vm._s(_vm.workSphere))])], 1) : _vm._e(), (_vm.professionStandarts) ? _c('div', [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "bold"
    }
  }, [_vm._v("Профессиональный стандарт:")]), _c('AppText', {
    attrs: {
      "mod": "small"
    }
  }, [_vm._v(_vm._s(_vm.professionStandarts))])], 1) : _vm._e(), (_vm.payLevel) ? _c('div', [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "bold"
    }
  }, [_vm._v("Уровень оплаты труда:")]), _c('AppText', {
    attrs: {
      "mod": "small"
    }
  }, [_vm._v(_vm._s(_vm.payLevel))])], 1) : _vm._e(), (_vm.sidebar && _vm.sidebar.paymentSize) ? _c('div', [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "bold"
    }
  }, [_vm._v("Размер оплаты труда:")]), _c('AppText', {
    attrs: {
      "mod": "small"
    }
  }, [_vm._v(_vm._s(_vm.sidebar.paymentSize))])], 1) : _vm._e(), (_vm.sidebar && _vm.sidebar.links.length) ? _c('div', [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "bold"
    }
  }, [_vm._v("Ссылки:")]), _vm._l((_vm.sidebar.links), function(ref, index) {
    var link = ref.link;
    var description = ref.description;

    return _c('AppRegularLink', {
      key: index,
      attrs: {
        "target": "_blank",
        "mod": "block, small",
        "href": link
      }
    }, [_vm._v(_vm._s(description))])
  })], 2) : _vm._e()]), _c('template', {
    slot: "main"
  }, [(_vm.main && _vm.main.description) ? _c('AppHtmlRender', {
    attrs: {
      "mod": "big",
      "htmlString": _vm.main.description
    }
  }) : _vm._e(), (_vm.main && _vm.main.qualitiesDesc) ? _c('AppCardDescriptionBlockLayout', [_c('AppTypeIcon', {
    attrs: {
      "type": "base"
    }
  }), _c('AppHeading', {
    attrs: {
      "level": "3",
      "mod": "bold, uppercase, no-bottom"
    }
  }, [_vm._v("Качества, которыми должен обладать специалист")]), _c('AppHtmlRender', {
    attrs: {
      "mod": "big",
      "htmlString": _vm.main.qualitiesDesc
    }
  })], 1) : _vm._e(), (_vm.main && _vm.main.interestsDesc) ? _c('AppCardDescriptionBlockLayout', [_c('AppTypeIcon', {
    attrs: {
      "type": "doc"
    }
  }), _c('AppHeading', {
    attrs: {
      "level": "3",
      "mod": "bold, uppercase, no-bottom"
    }
  }, [_vm._v("Интересы, наличие которых рекомендовано для освоения профессии")]), _c('AppHtmlRender', {
    attrs: {
      "mod": "big",
      "htmlString": _vm.main.interestsDesc
    }
  })], 1) : _vm._e(), (_vm.main && _vm.main.contraindicationsDesc) ? _c('AppCardDescriptionBlockLayout', [_c('AppTypeIcon', {
    attrs: {
      "type": "warning"
    }
  }), _c('AppHeading', {
    attrs: {
      "level": "3",
      "mod": "bold, uppercase, no-bottom"
    }
  }, [_vm._v("Противопоказания")]), _c('AppHtmlRender', {
    attrs: {
      "mod": "big",
      "htmlString": _vm.main.contraindicationsDesc
    }
  })], 1) : _vm._e()], 1)], 2)], 1), (_vm.listOfCards.length) ? _c('ExtraLayout', {
    staticClass: "extra_layout",
    attrs: {
      "bg": "gray"
    }
  }, _vm._l((_vm.listOfCards), function(item) {
    return _c('AppCardsList', _vm._b({
      key: item.title
    }, 'AppCardsList', item, false))
  }), 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c11fb55e","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/professions/card/ProfessionCard.vue
// module id = a11021782650aac6ac2d
// module chunks = 34